// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const ubn: CountryValidator<"TW"> = createValidator(
  "tw.ubn",
  166,
);

export default ubn;
export const compact = ubn.compact;
export const format = ubn.format;
export const validate = ubn.validate;
export const generate = (): string =>
  ubn.generate?.() ??
  (() => {
    throw new Error(
      "Validator tw.ubn cannot generate values",
    );
  })();
